module.exports = __webpack_public_path__ + "static/media/candado.374919b4.svg";